// Dispatcher: the day's plans with live stop status per van.
import { listPlans, routesForPlans, watchStops, setPlanStatus, deletePlan, todayIST } from '../lib/api.js';
import { fmtClock } from '../lib/planner.js';
import { $, $$, esc, busy, toast, makeMap, numberIcon, statusChip, L } from '../lib/ui.js';

export async function renderBoard(app) {
  app.innerHTML = '<div class="side" id="side"></div><div class="map" id="map"></div>';
  const map = makeMap($('#map'));
  const layer = L.layerGroup().addTo(map);
  const side = $('#side');
  let date = todayIST();
  let plans = [], routes = [];

  async function load() {
    side.innerHTML = '<p class="pad">Loading…</p>';
    try {
      plans = await listPlans(date);
      routes = await routesForPlans(plans.map(p => p.id));
    } catch (e) { side.innerHTML = `<div class="err">${esc(e.message)}</div>`; return; }
    render();
  }

  function render() {
    layer.clearLayers();
    const pts = [];
    let html = `<div class="bar"><label>Date <input type="date" id="date" value="${date}"></label><button id="reload">Refresh</button></div>`;
    if (!plans.length) html += '<p class="pad">No plans for this date. Make one under <a href="#/plan">Plan</a>.</p>';
    plans.forEach(p => {
      const pr = routes.filter(r => r.plan_id === p.id);
      const stops = pr.flatMap(r => r.stops);
      const done = stops.filter(s => s.status !== 'pending').length;
      html += `<div class="summary"><b>Plan ${esc(new Date(p.created_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }))}</b>
        · ${statusChip(p.status)} · ${done}/${stops.length} stops done
        <div class="ctl">
          ${p.status === 'draft' ? `<button data-pub="${p.id}">Publish</button>` : ''}
          ${p.status === 'published' ? `<button data-done="${p.id}">Mark day done</button>` : ''}
          ${p.status === 'draft' ? `<button class="warn" data-del="${p.id}">Delete draft</button>` : ''}
        </div></div>`;
      pr.forEach(r => {
        if (r.geometry && p.status !== 'draft') layer.addLayer(L.geoJSON(r.geometry, { style: { color: r.color, weight: 4, opacity: 0.7 } }));
        html += `<div class="row" style="border-left:6px solid ${r.color}"><div class="grow">
          <div class="name">Van ${r.van_no} — ${esc(r.driver?.full_name || 'no driver')}</div>
          <div class="addr">${r.stops.length} stops · ${((r.distance_m || 0) / 1000).toFixed(1)} km · back ~${fmtClock(r.back_by_min ?? 0)}</div></div></div>`;
        r.stops.forEach(s => {
          const loc = s.location || {};
          if (Number.isFinite(loc.lat)) {
            pts.push([loc.lat, loc.lng]);
            const col = s.status === 'delivered' ? '#2e8b57' : s.status === 'failed' ? '#b91c1c' : r.color;
            layer.addLayer(L.marker([loc.lat, loc.lng], { icon: numberIcon(`${r.van_no}.${s.seq}`, col) })
              .bindPopup(`<b>${esc(loc.name)}</b><br>${esc(s.status)}${s.note ? ': ' + esc(s.note) : ''}`));
          }
          html += `<div class="row" data-stop="${s.id}"><div class="badge" style="background:${r.color}">${s.seq}</div><div class="grow">
            <div class="name">${esc(loc.name)} ${statusChip(s.status)}</div>
            <div class="addr"><span class="eta">ETA ~${fmtClock(s.eta_min ?? 0)}</span>${s.done_at ? ' · done ' + new Date(s.done_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' }) : ''}${s.note ? ' · “' + esc(s.note) + '”' : ''}</div>
          </div></div>`;
        });
      });
    });
    side.innerHTML = html;
    if (pts.length) { map.invalidateSize(); map.fitBounds(L.featureGroup(layer.getLayers()).getBounds().pad(0.1)); }
    $('#date').onchange = e => { date = e.target.value; load(); };
    $('#reload').onclick = load;
    $$('[data-pub]', side).forEach(b => b.onclick = () => busy(b, async () => { await setPlanStatus(b.dataset.pub, 'published'); toast('Published.'); load(); }).catch(() => {}));
    $$('[data-done]', side).forEach(b => b.onclick = () => busy(b, async () => { await setPlanStatus(b.dataset.done, 'done'); load(); }).catch(() => {}));
    $$('[data-del]', side).forEach(b => b.onclick = () => {
      if (confirm('Delete this draft plan?')) busy(b, async () => { await deletePlan(b.dataset.del); load(); }).catch(() => {});
    });
  }

  // Live: patch the changed stop in memory and re-render.
  const stop = watchStops(changed => {
    for (const r of routes) {
      const s = r.stops.find(x => x.id === changed.id);
      if (s) { Object.assign(s, changed); render(); toast(`${s.location?.name || 'Stop'}: ${changed.status}`); return; }
    }
  });

  await load();
  return () => { stop(); map.destroy(); };
}
